import type { TicketStatus } from '@yhelp/shared-types';

const TRANSITIONS: Record<TicketStatus, TicketStatus[]> = {
  aberto: ['em_andamento', 'em_espera', 'cancelado'],
  em_andamento: ['em_espera', 'resolvido', 'cancelado'],
  em_espera: ['em_andamento', 'cancelado'],
  resolvido: ['fechado', 'reaberto'],
  reaberto: ['em_andamento', 'cancelado'],
  fechado: [],
  cancelado: [],
};

export function allowedNextStatuses(from: TicketStatus): TicketStatus[] {
  return TRANSITIONS[from] ?? [];
}

export function statusLabel(status: string): string {
  return status.replace(/_/g, ' ');
}
